"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _react = _interopRequireWildcard(require("react"));

var _atom = require("atom");

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _DealRecord = _interopRequireDefault(require("customer-data-objects/deal/DealRecord"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _DealStageIdSelect = _interopRequireDefault(require("customer-data-objects-ui-components/deal/DealStageIdSelect"));

var _utils = require("reference-resolvers/utils");

var propTypes = {
  nextPipeline: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  placeholder: _react.PropTypes.string,
  resolver: _ReferenceResolverType.default.isRequired,
  subject: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_DealRecord.default), _react.PropTypes.instanceOf(_immutable.Map)]).isRequired,
  value: _react.PropTypes.node
};

var PropertyInputDealStage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PropertyInputDealStage, _PureComponent);

  function PropertyInputDealStage() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputDealStage);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputDealStage).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      pipelines: (0, _immutable.Map)()
    };
    return _this;
  }

  (0, _createClass2.default)(PropertyInputDealStage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initReferenceAtom();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.referenceAtom) {
        (0, _atom.unwatch)(this.referenceAtom, this.handlePipelinesReferenceChange);
      }
    }
  }, {
    key: "initReferenceAtom",
    value: function initReferenceAtom() {
      this.referenceAtom = this.props.resolver.all();
      (0, _atom.watch)(this.referenceAtom, this.handlePipelinesReferenceChange);
      this.handlePipelinesReferenceChange((0, _atom.deref)(this.referenceAtom));
    }
  }, {
    key: "handlePipelinesReferenceChange",
    value: function handlePipelinesReferenceChange(reference) {
      if (!(0, _utils.isResolved)(reference)) {
        return;
      }

      var pipelines = reference.reduce(function (acc, _ref) {
        var pipeline = _ref.referencedObject;
        return acc.set(pipeline.get('pipelineId'), pipeline);
      }, (0, _immutable.Map)());
      this.setState({
        pipelines: pipelines
      });
    }
  }, {
    key: "getDealStages",
    value: function getDealStages() {
      var _this$props = this.props,
          nextPipeline = _this$props.nextPipeline,
          subject = _this$props.subject;
      var pipelines = this.state.pipelines;
      var stageOptions = pipelines.getIn([nextPipeline || (0, _ObjectRecordAccessors.getProperty)(subject, 'pipeline') || subject.get('pipeline') || pipelines.size && pipelines.first().get('pipelineId'), 'stages']);

      if (!stageOptions) {
        return undefined;
      }

      return stageOptions.sortBy(function (stage) {
        return stage.get('displayOrder');
      }).map(function (stage) {
        return stage.set('value', stage.get('stageId'));
      }).map(function (stage) {
        return stage.set('text', stage.get('label'));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_DealStageIdSelect.default, (0, _extends2.default)({}, this.props, {
        dealStages: this.getDealStages(),
        menuWidth: 300,
        placement: "bottom right"
      }));
    }
  }]);
  return PropertyInputDealStage;
}(_PureComponent2.default);

PropertyInputDealStage.propTypes = propTypes;
var _default = PropertyInputDealStage;
exports.default = _default;
module.exports = exports.default;